module.exports = __webpack_public_path__ + "assets/icons/ic_check_circle_24px.svg";